<svg xmlns="http://www.w3.org/2000/svg" [attr.width]="size" [attr.height]="size" viewBox="0 0 24 24">
  <rect class="equalizer equalizer--1" x="4" y="4" width="3.7" height="8" [attr.fill]="color"/>
  <rect class="equalizer equalizer--2" x="10.2" y="4" width="3.7" height="16" [attr.fill]="color"/>
  <rect class="equalizer equalizer--3" x="16.3" y="4" width="3.7" height="11" [attr.fill]="color"></rect>
</svg>
